import { WorkspaceContext } from "@sg-protect/shell";
import { useContext } from "react";
import { Navigate } from "react-router";
import { Routes } from "../constants.ts";

export function MigrateRootRedirect() {
    const currentWorkspace = useContext(WorkspaceContext)?.currentWorkspace;

    if (currentWorkspace) {
        return <Navigate to={`/migrate/${currentWorkspace.id}`} replace />;
    }

    return <Navigate to={Routes.assessment} replace />;
}
